import { cx } from "@emotion/css";

import EntranceSpotExampleImg from "@/assets/entrance-example.png";
import EntranceNgEmOne from "@/assets/entrance-ng-shadow-1.png";
import EntranceNgEmTwo from "@/assets/entrance-ng-shadow-2.png";
import EntranceNgEmThree from "@/assets/entrance-ng-tool-1.png";
import EntranceNgEmFour from "@/assets/entrance-ng-tool-2.png";

export interface EntrancePhotoExamplesProps {
  /** When placed above the form, reduce top margin on the section title. */
  position?: "above" | "below";
}

/**
 * Entrance photo help (legacy UI: OK/NG with thumbnail grids).
 *
 * Used by `EntranceSpot` and `GateSpot` (inside CreateButtonGroup). `PATMOSpot` and
 * `LiteSpot` use `EntrancePhotoGuide` instead.
 */
export const EntrancePhotoExamples = ({ position = "below" }: EntrancePhotoExamplesProps) => {
  const titleMarginTop = position === "above" ? "mt-0" : "mt-10";

  return (
    <>
      <p className={cx("mb-5 text-center font-semibold", titleMarginTop)}>入口の写真について</p>
      <div className="flex flex-col gap-5 text-sm leading-6">
        <p>
          できるだけ正面から撮影してください。手ブレや
          人の映り込みに注意してください
        </p>
        <div>
          <TinyBar />
          OK例：正面から撮影し、どのドアかがわかりやすい
          <Image src={EntranceSpotExampleImg} alt="" className="mt-[10px]" />
        </div>

        <div>
          <TinyBar />
          NG例：ぶれている、人が映り込んでいる
          <div className="mt-2 flex gap-2">
            <Image src={EntranceNgEmOne} alt="" />
            <Image src={EntranceNgEmTwo} alt="" />
          </div>
        </div>

        <div>
          <TinyBar />
          NG例：脚立や工具が映り込んでいる、ドアが開いている
          <div className="mt-2 flex gap-2">
            <Image src={EntranceNgEmThree} alt="" />
            <Image src={EntranceNgEmFour} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

const TinyBar = () => (
  <span className="mr-1 mt-1.5 inline-block h-3 w-[3px] shrink-0 bg-primary" aria-hidden />
);

interface ImageProps {
  className?: string;
}
const Image = ({
  className,
  ...props
}: ImageProps & React.ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <div className="flex-1">
      <img {...props} className={cx("left-0 top-0 w-full", className)} />
    </div>
  );
};
